import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Table, TitleWithActions } from 'components/components';
import StaticNotification from 'components/components/Notification/StaticNotification';
import { VentureBuilderListItemType, useVentureBuilders } from 'packages/venture_builder_repository';
import { composeVentureBuilderDetailsUrl } from 'routes/routeComposers';
import { VentureBuildersOverviewProps } from 'types/ventureBuilders';
import {
  DRAWERS, getOffset, isEitherAdmin, useTableHook,
} from 'utils';
import ventureBuildersColumns from './utils/columns';

const VentureBuildersOverview = ({
  userType,
  actions: { setDrawerBody, setIsDrawerOpen, setTableLayout },
}: VentureBuildersOverviewProps) => {
  const history = useHistory();
  const { state: { limit, currentPage }, setLimit, setCurrentPage } = useTableHook();
  const [searchString, setSearchString] = useState('');

  const { data, isFetching, error } = useVentureBuilders({
    limit,
    offset: getOffset(limit, currentPage),
    searchString,
  });

  useEffect(() => {
    setTableLayout({ isRowTableLayout: true });
  }, [setTableLayout]);

  const onSearch = (value: string) => {
    setSearchString(value);
    setCurrentPage(1);
  };

  const onAddButtonClick = () => {
    setDrawerBody({ drawerBody: DRAWERS.addVentureBuilder });
    setIsDrawerOpen({ isDrawerOpen: true });
  };

  const openDetails = (record: VentureBuilderListItemType) => history.push(composeVentureBuilderDetailsUrl(record.id));

  return (
    <div className="content-container venture-builders-overview">
      <TitleWithActions title="Venture Builders" size="m" />
      {error && <StaticNotification type="warning" message={`Unable to load Venture Builders: ${error.message}`} />}
      <Table
        isLoading={isFetching}
        showSearchBar
        showSearchField
        showLeftContent
        leftContent={isEitherAdmin(userType) ? 'add-button' : undefined}
        addButtonText="venture builder"
        searchString={searchString}
        setSearchString={onSearch}
        placeholder="venture builder"
        onAddButtonClick={onAddButtonClick}
        dataSource={data?.items || []}
        columns={ventureBuildersColumns}
        rowKey="id"
        onRow={(record: VentureBuilderListItemType) => ({ onClick: () => openDetails(record) })}
        onGridCardClick={() => null}
        showCustomPagination
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setLimit={setLimit}
        total={data?.total || 0}
        isFilterButtons={false}
      />
    </div>
  );
};

export default VentureBuildersOverview;
